module.exports = __webpack_public_path__ + "img/2022_0.249d32ab.webp";